import TableBusiness from "./Table";
export default TableBusiness;